(function($) {
    $(document).ready(function() {

        $('.js-hamburger').on('click', function(e) {
            e.preventDefault();
            $('.js-hamburger').toggleClass('active');
            $('.side-menu').toggleClass('is-open');
            $('.content-overlay').toggleClass('is-active');
            $('body').toggleClass('no-scroll');
        });


        // bind this first
        // when the menu arrow is clicked
        $(document).on('click', '.menu-arrow', function() {
            var $submenu = $(this).prev('.sub-menu, .children');
            $submenu.toggleClass('is-open');
            $submenu.slideToggle();
        });

        $('.product-categories').addClass('nav');

        // remove all is-open classes and add them to the correct submenus
        // create a function and make it available in other scripts
        window.setSubMenuHeight = function() {

            // add an arrow to menu items that have a submenu
            if ($('.menu-arrow').length < 1) {
                $('.side-menu .menu-item-has-children, .sidebar .menu-item-has-children, .product-categories .cat-parent').append('<div class="menu-arrow"><i class="fa fa-chevron-down"></i><div>');
            }

            $('#navigation .sub-menu').removeClass('is-open');
            $('#navigation .current-menu-item > .sub-menu,  #navigation .current-menu-ancestor > .sub-menu').addClass('is-open');
        };

        // add is-open to the correct submenus
        window.setSubMenuHeight();

        fixedMenu = function() {
            $offset = $('.header-inner').height();
            if ($(window).scrollTop() >= $offset) {
                // $('.sibling-navigation').addClass('is-fixed');
                $('.n-header-donate, .n-header-shop').addClass('is-fixed');
                $('.hamburger').addClass('is-fixed');
                $('.side-menu').addClass('is-scrolling');
                // $('.header').css('padding-bottom', '50px');
            }
            if ($(window).scrollTop() < $offset) {
                // $('.sibling-navigation').removeClass('is-fixed');
                $('.n-header-donate, .n-header-shop').removeClass('is-fixed');
                $('.hamburger').removeClass('is-fixed');
                $('.side-menu').removeClass('is-scrolling');
                // $('header').css('padding-bottom', '0');
            }
        };

        $(window).scroll(function() {
            //if you hard code, then use console
            //.log to determine when you want the 
            //nav bar to stick.  
            // console.log($(window).scrollTop());

            fixedMenu();
        });

    });
})(jQuery);
